import { Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';
import { categories } from '@/mocks/categories';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import PopularSidebar from '@/pages/home/components/PopularSidebar';
import VideoGrid from '@/components/feature/VideoGrid';

const featuredVideos = videos.filter((v) => v.featured).slice(0, 5);
const latestVideos = [...videos].sort((a, b) => (a.uploadDate < b.uploadDate ? 1 : -1)).slice(0, 6);
const popularVideos = [...videos].sort((a, b) => b.views - a.views).slice(0, 8);

const highlights = [
  {
    icon: 'ri-hd-line',
    title: '高清画质',
    text: '聚合多类别高清视频内容，封面与画面清晰，浏览体验更舒服。',
  },
  {
    icon: 'ri-apps-2-line',
    title: '分类清晰',
    text: '娱乐、生活、搞笑等分类一目了然，想看的类型一点就到。',
  },
  {
    icon: 'ri-share-forward-line',
    title: '一键分享',
    text: '看到喜欢的视频随手复制链接分享给朋友，快乐不独享。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '即点即看',
    text: '无需登录注册，打开即看，把时间都留给内容本身。',
  },
];

export default function Home() {
  const totalViews = videos.reduce((sum, v) => sum + v.views, 0);

  return (
    <div className="bg-background-50 animate-fade-up">
      <HeroCarousel videos={featuredVideos} />

      <CategoryGrid />

      <section className="w-full px-4 md:px-8 mt-12 md:mt-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-end justify-between mb-5 md:mb-7">
              <div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">最新上传</h2>
                <p className="mt-1 text-sm text-foreground-600">刚刚更新的热门内容，抢先看</p>
              </div>
              <Link
                to="/category/entertainment"
                className="text-sm text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap"
              >
                全部分类 <i className="ri-arrow-right-s-line align-middle"></i>
              </Link>
            </div>
            <VideoGrid videos={latestVideos} columns="grid-cols-1 sm:grid-cols-2" />
          </div>

          <div className="lg:col-span-1 space-y-6">
            <PopularSidebar videos={popularVideos} />
            <div className="rounded-lg overflow-hidden border border-background-200 bg-secondary-100 p-5">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500 text-background-950 text-xl">
                <i className="ri-bar-chart-box-line"></i>
              </span>
              <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">本周热度</h3>
              <p className="mt-2 text-sm text-foreground-700 leading-relaxed">
                全站累计播放已达{' '}
                <strong className="text-accent-400 font-semibold">{(totalViews / 100000000).toFixed(2)} 亿</strong> 次，
                覆盖 {categories.length} 大分类，持续为你更新。
              </p>
              <Link
                to="/search"
                className="mt-4 inline-flex items-center gap-2 h-10 px-5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors whitespace-nowrap"
              >
                去发现更多
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-8 mt-14 md:mt-20">
        <div className="bg-background-100 border border-background-200 rounded-lg p-6 md:p-10">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-medium">
              <i className="ri-sparkling-2-line"></i>
              关于靠逼视频
            </span>
            <h2 className="mt-4 font-heading text-xl md:text-3xl font-bold text-foreground-950">
              一个专注高清视频的在线观看与分享平台
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              靠逼视频汇聚娱乐、生活、搞笑、音乐、运动、游戏等多个类别的优质视频内容，为追求丰富观看体验的用户提供便捷的浏览、筛选、观看与分享服务。我们相信，好内容值得被更多人轻松看到。
            </p>
          </div>
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {highlights.map((h) => (
              <div key={h.title} className="bg-background-50 border border-background-200 rounded-lg p-5">
                <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-500/15 text-primary-400 text-2xl">
                  <i className={h.icon}></i>
                </span>
                <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950">{h.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{h.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-8 mt-14 md:mt-20">
        <div className="relative rounded-lg overflow-hidden h-[240px] md:h-[300px]">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20warm%20cinematic%20gradient%20background%20with%20soft%20glowing%20orange%20and%20amber%20light%20streaks%20on%20deep%20navy%20base%2C%20minimal%20elegant%20texture%2C%20subtle%20film%20grain%2C%20high%20detail%20artistic%20render&width=1920&height=600&seq=vs-cta&orientation=landscape"
            alt="靠逼视频 内容征集"
            title="靠逼视频 - 高清视频在线观看"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background-950/90 via-background-950/70 to-background-950/30"></div>
          <div className="absolute inset-0 flex flex-col justify-center px-6 md:px-12">
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 max-w-xl">
              有喜欢的视频类别？搜索发现更多精彩
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-700 max-w-lg">
              输入关键词即可在全站范围内查找视频标题与简介，快速定位你想看的内容。
            </p>
            <Link
              to="/search"
              className="mt-5 self-start inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold transition-colors whitespace-nowrap"
            >
              <i className="ri-search-line"></i>
              开始搜索
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}